import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isUngatedForUnifiedAcademyNavigation", "children"];
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useMediaQuery } from '../../../utils/Styling';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ProfileCardWrapper = _ref => {
  let {
      isUngatedForUnifiedAcademyNavigation,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isTablet
  } = useMediaQuery();
  if (!isUngatedForUnifiedAcademyNavigation) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    marginBlockEnd: "0",
    paddingBlock: "400",
    paddingInline: isTablet ? '500' : '1000'
  }, props, {
    children: children
  }));
};